
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 13a6.5 6.5 0 116.5-6.5A6.5 6.5 0 0112 13zm0-12a5.5 5.5 0 105.5 5.5A5.5 5.5 0 0012 1zm7.5 23h-1v-2.5a6.5 6.5 0 00-13 0V24h-1v-2.5a7.5 7.5 0 0115 0z"}})])
          )
        }
      }
    